import React from "react";

import { Card } from "@/components/ui/Card";
import Skeleton from "@/components/shared/Skeleton";


export const WidgetCard = ({ icon: Icon, title, insight, loading, right, children, className = "" }) => (
    <Card className={"p-0 overflow-hidden flex flex-col h-full " + className}>
        <div className="px-4 py-3 border-b border-border-primary flex items-center justify-between gap-2">
            <div className="flex items-center gap-1.5 min-w-0">
                {Icon ? <Icon size={14} className="text-text-primary/70 flex-shrink-0" /> : null}
                <h3 className="text-sm font-semibold text-text-primary truncate">{title}</h3>
            </div>
            {right ? <div className="flex-shrink-0">{right}</div> : null}
        </div>
        {/* Insight line — the pre-computed takeaway. */}
        {loading ? (
            <div className="px-4 pt-3">
                <Skeleton className="h-3 w-2/3" />
            </div>
        ) : insight ? (
            <p className="px-4 pt-3 text-[12px] leading-snug text-text-secondary">
                <span className="text-text-primary font-medium">{insight}</span>
            </p>
        ) : null}
        <div className="p-4 flex flex-col gap-3 flex-1">{children}</div>
    </Card>
);

// A single hero KPI tile — a big diagnostic figure with a caption and optional
// sub-line. Not a volume count (those live on the recruitment dashboard); these
// are rates/durations. Accent bar on the left ties it to its section color.
export const KpiTile = ({ label, value, unit, sub, color, icon: Icon, loading }) => (
    <div
        className="rounded-xl p-4 h-full flex flex-col justify-between bg-background-secondary border border-border-primary"
        style={{ borderLeftWidth: 4, borderLeftColor: color }}
    >
        <div className="flex items-center gap-2">
            {Icon ? (
                <div
                    className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 border"
                    style={{ background: `${color}1a`, borderColor: `${color}33` }}
                >
                    <Icon size={15} style={{ color }} />
                </div>
            ) : null}
            <p className="text-[0.78rem] leading-tight text-text-secondary">{label}</p>
        </div>
        {loading ? (
            <Skeleton className="h-8 w-16 mt-2" />
        ) : (
            <div className="mt-2">
                <p className="text-[1.7rem] font-bold tracking-tight leading-none text-text-primary">
                    {value ?? "—"}
                    {value != null && unit ? (
                        <span className="text-[0.9rem] font-semibold text-text-secondary ml-0.5">{unit}</span>
                    ) : null}
                </p>
                {sub ? <p className="text-[10px] text-text-secondary mt-1 leading-tight">{sub}</p> : null}
            </div>
        )}
    </div>
);